import {SEARCH} from "../actions/";

export default (state = {}, action) => {
    switch (action.type) {
        case SEARCH:
            return action.payload;

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/reducer_search.js